import React from 'react';
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archivearrow.svg";
import '../../style.css';
function DeleteCircleIcon() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="40" fill="#FFF1F0" />
      <path d="M30 30L50 50" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M50 30L30 50" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Circle background behind archive arrow icon
function ArchiveIconWithCircle() {
  return (
    <span style={{ position: 'relative', width: 80, height: 80, display: 'inline-block' }}>
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', top: 0, left: 0 }}>
        <circle cx="40" cy="40" r="40" fill="#F9FAFA" />
      </svg>
      <span style={{ position: 'absolute', top: 0, left: 0, width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ArchiveIcon />
      </span>
    </span>
  );
}


export default function ArticleActionPopup({
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  IconComponent,
  popupType
}) {
  // pick proper icon
  const TopIcon = popupType === 'archive' ? ArchiveIconWithCircle : DeleteCircleIcon;
  return (
    <>
      <div className="overlay" />
      <div className="Team-PopUp-Container" style={{ top: '33%', padding: '24px', paddingTop: '32px' }}>
        <div className="Team-PopUp-Header-Group" style={{ position: 'absolute', top: '26px', right: '32px' }}>
          <p className="PopUp-Text02" onClick={onCancel}>
            <Close />
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <TopIcon />
          <p className="DeleteFile-text" style={{ marginTop: 28 }}>{title}</p>
          <p className="DeleteFile-text01" style={{ marginTop: 8, textAlign: 'center', maxWidth: 350 }}>
            {description}
          </p>
        </div>
        <div className="Deletegroup-delete-container">
          <button className="Deletegroup-cancel01" type="button" onClick={onCancel} style={{ width: '176px' }}>
            {cancelText}
          </button>
          <button className="Deletegroup-delete01" type="button" onClick={onConfirm} style={{ width: '192px' }}>
            {confirmText}
          </button>
        </div>
      </div>
    </>
  );
}
